import { TemplatingContextType } from '@tyro/api';
import { PageContainer, PageHeading, TabPageContainer } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { useLocation } from '@tyro/router/hooks';
import { getTemplateType } from '../utils/get-template-type';

export const templatesPaths: Record<
  string,
  | TemplatingContextType.Staff
  | TemplatingContextType.Student
  | TemplatingContextType.Person
  | TemplatingContextType.Contact
> = {
  students: TemplatingContextType.Student,
  contacts: TemplatingContextType.Contact,
  staff: TemplatingContextType.Staff,
  person: TemplatingContextType.Person,
};

export default function TemplatesContainer() {
  const { t } = useTranslation(['common', 'templates']);
  const pathname = useLocation().pathname;
  const templateType = getTemplateType(pathname);
  const title =
    templateType === null
      ? t('templates:templateTitles.templates')
      : t(`templates:templateTitles.${templateType}`);

  return (
    <PageContainer title={t('templates:title')}>
      <PageHeading title={title} titleProps={{ variant: 'h3' }} />
      <TabPageContainer
        links={[
          {
            label: t('common:contactsOfStudents'),
            value: 'contacts',
          },
          {
            label: t('common:staff'),
            value: 'staff',
          },
          {
            label: t('common:students'),
            value: 'students',
          },
          {
            label: t('common:person'),
            value: 'person',
          },
        ]}
      />
    </PageContainer>
  );
}
